import "./ProyectosCommon.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { CatalogoItemResponse } from "../../../shared/response/proyectos/CatalogoItemResponse";
import { FaseResponse } from "../../../shared/response/proyectos/FaseResponse";
import { CatalogoItemPayload } from "../../../shared/services/api/payload/proyectos/CatalogoItemPayload";
import { CatalogoItemSaveService } from "../../services/proyectos/CatalogoItemSaveService";

const TIPOP_OPCIONES: { value: string; label: string }[] = [
  { value: "fijo", label: "Fijo — precio estático, lo actualiza el admin a mano" },
  { value: "ipc", label: "IPC — escala con la tasa de la cosecha vigente" },
  { value: "smmlv", label: "SMMLV — usa el factor jornal del snapshot activo" },
  { value: "volatil", label: "Volátil — insumo atado a dólar, precio manual" },
];
const INCL_OPCIONES: { value: string; label: string }[] = [
  { value: "obligatorio", label: "Obligatorio (no se puede quitar)" },
  { value: "incluido", label: "Incluido (se puede quitar)" },
  { value: "opcional", label: "Opcional (inactivo por defecto)" },
];
const FREQ_UNIDADES = ["apps", "meses", "veces", "visitas"];

/**
 * Crea o edita un ítem del catálogo maestro con TODOS sus campos -antes solo existía el modal de
 * solo-precio (CatalogoPrecioModal)-. Tipo/Sec no se editan aquí: el servidor los deriva de la
 * fase elegida (Fase.Tipo), ver CatalogoItemRequest/Catalogo.SaveService.
 */
export class CatalogoItemFormModal extends BaseSmallModalFormComponent<
  CatalogoItemResponse,
  CatalogoItemPayload,
  CatalogoItemSaveService
> {
  private _nombre!: HTMLInputElement;
  private _fase!: HTMLSelectElement;
  private _sub!: HTMLInputElement;
  private _categoria!: HTMLInputElement;
  private _tipoP!: HTMLSelectElement;
  private _cantidadPorHa!: HTMLInputElement;
  private _unidad!: HTMLInputElement;
  private _cantUnidad!: HTMLInputElement;
  private _freq!: HTMLInputElement;
  private _freqUnidad!: HTMLSelectElement;
  private _precio!: HTMLInputElement;
  private _incl!: HTMLSelectElement;
  private _nitro!: HTMLInputElement;
  private _formula!: HTMLElement;

  constructor(
    private readonly _cultivoId: string,
    private readonly _fases: FaseResponse[],
    private readonly _categoriasSugeridas: string[],
    private readonly _subsSugeridas: string[],
    private readonly _onSavedCb: (item: CatalogoItemResponse) => void,
    private readonly _item?: CatalogoItemResponse,
  ) {
    super(new CatalogoItemSaveService());
  }

  protected get title(): string { return this._item ? "Editar ítem del catálogo" : "Nuevo ítem del catálogo"; }
  protected get saveText(): string { return "Guardar ítem"; }

  protected renderBody(): string {
    const it = this._item;
    return `
      <div class="cl-form-fields">
        <div class="cl-form-group">
          <label class="cl-form-label" for="mf-nombre">Nombre del ítem <span class="cl-required">*</span></label>
          <input id="mf-nombre" class="sx-input" type="text" maxlength="200" value="${this._esc(it?.nombre ?? "")}" placeholder="Ej: Urea (46-0-0)">
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-fase">Fase <span class="cl-required">*</span></label>
            <select id="mf-fase" class="sx-input">
              ${this._fases.map((f) => `<option value="${f.id}" ${it?.faseId === f.id ? "selected" : ""}>${f.codigo} — ${this._esc(f.nombre)}</option>`).join("")}
            </select>
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-sub">Subsección <span class="cl-required">*</span></label>
            <input id="mf-sub" class="sx-input" type="text" maxlength="150" list="mf-subs" value="${this._esc(it?.sub ?? "")}" placeholder="Ej: Fertilización">
            <datalist id="mf-subs">${this._subsSugeridas.map((s) => `<option value="${this._esc(s)}">`).join("")}</datalist>
          </div>
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="mf-cat">Categoría <span class="cl-required">*</span></label>
          <input id="mf-cat" class="sx-input" type="text" maxlength="100" list="mf-cats" value="${this._esc(it?.categoria ?? "")}" placeholder="Ej: Fertilizantes">
          <datalist id="mf-cats">${this._categoriasSugeridas.map((c) => `<option value="${this._esc(c)}">`).join("")}</datalist>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-tipop">Tipo de precio <span class="cl-required">*</span></label>
            <select id="mf-tipop" class="sx-input">
              ${TIPOP_OPCIONES.map((o) => `<option value="${o.value}" ${it?.tipoP === o.value ? "selected" : ""}>${o.label}</option>`).join("")}
            </select>
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-precio">Precio unitario (COP)</label>
            <input id="mf-precio" class="sx-input sx-input--numeric" type="number" min="0" step="1" value="${it?.precioReferencial ?? ""}" placeholder="Sin precio">
          </div>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-qty">Cantidad por hectárea <span class="cl-required">*</span></label>
            <input id="mf-qty" class="sx-input sx-input--numeric" type="number" min="0" step="any" value="${it?.cantidadPorHa ?? ""}" placeholder="Ej: 500">
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-unidad">Unidad de precio <span class="cl-required">*</span></label>
            <input id="mf-unidad" class="sx-input" type="text" maxlength="50" list="mf-unidades" value="${this._esc(it?.unidad ?? "")}" placeholder="Ej: COP/Kg">
            <datalist id="mf-unidades"><option value="COP/Kg"><option value="COP/Und"><option value="COP/Jornal"><option value="COP/L"><option value="COP/Ha Año"></datalist>
          </div>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-cantunidad">Unidad de cantidad <span class="cl-required">*</span></label>
            <input id="mf-cantunidad" class="sx-input" type="text" maxlength="50" list="mf-cantunidades" value="${this._esc(it?.cantUnidad ?? "")}" placeholder="Ej: Kg/Ha">
            <datalist id="mf-cantunidades"><option value="Kg/Ha"><option value="L/Ha"><option value="Und/Ha"><option value="Jornal/Ha"><option value="M/Ha"><option value="Global"><option value="Visita"></datalist>
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-freq">Frecuencia</label>
            <div style="display:flex;gap:6px">
              <input id="mf-freq" class="sx-input sx-input--numeric" type="number" min="0" step="any" value="${it?.freq ?? 1}" style="flex:1">
              <select id="mf-frequnidad" class="sx-input" style="flex:1">
                <option value="">— sin unidad —</option>
                ${FREQ_UNIDADES.map((u) => `<option value="${u}" ${it?.freqUnidad === u ? "selected" : ""}>${u}</option>`).join("")}
              </select>
            </div>
            <span class="pr-form-note">Repeticiones dentro de la fase (ej. 3 aplicaciones).</span>
          </div>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="mf-incl">Inclusión en proyectos <span class="cl-required">*</span></label>
            <select id="mf-incl" class="sx-input">
              ${INCL_OPCIONES.map((o) => `<option value="${o.value}" ${it?.incl === o.value ? "selected" : ""}>${o.label}</option>`).join("")}
            </select>
          </div>
          <div class="cl-form-group" style="justify-content:flex-end">
            <label class="cl-form-label" style="display:flex;align-items:center;gap:6px;margin-bottom:0">
              <input id="mf-nitro" type="checkbox" ${it?.nitro ? "checked" : ""}> Producto Nitrofert
            </label>
          </div>
        </div>
        <div class="pr-panel" style="padding:10px 14px;display:flex;justify-content:space-between;align-items:center">
          <span style="font-size:var(--sx-text-xs);color:var(--sx-text-tertiary)">Total por hectárea <span id="mf-formula"></span></span>
          <strong id="mf-total">$0</strong>
        </div>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._nombre       = el.querySelector<HTMLInputElement>("#mf-nombre")!;
    this._fase         = el.querySelector<HTMLSelectElement>("#mf-fase")!;
    this._sub          = el.querySelector<HTMLInputElement>("#mf-sub")!;
    this._categoria    = el.querySelector<HTMLInputElement>("#mf-cat")!;
    this._tipoP        = el.querySelector<HTMLSelectElement>("#mf-tipop")!;
    this._cantidadPorHa = el.querySelector<HTMLInputElement>("#mf-qty")!;
    this._unidad       = el.querySelector<HTMLInputElement>("#mf-unidad")!;
    this._cantUnidad   = el.querySelector<HTMLInputElement>("#mf-cantunidad")!;
    this._freq         = el.querySelector<HTMLInputElement>("#mf-freq")!;
    this._freqUnidad   = el.querySelector<HTMLSelectElement>("#mf-frequnidad")!;
    this._precio       = el.querySelector<HTMLInputElement>("#mf-precio")!;
    this._incl         = el.querySelector<HTMLSelectElement>("#mf-incl")!;
    this._nitro        = el.querySelector<HTMLInputElement>("#mf-nitro")!;
    this._formula      = el.querySelector<HTMLElement>("#mf-formula")!;

    [this._nombre, this._sub, this._categoria, this._unidad, this._cantUnidad].forEach((i) =>
      i.addEventListener("input", () => this._validate()));
    [this._cantidadPorHa, this._freq, this._precio, this._tipoP].forEach((i) =>
      i.addEventListener("input", () => { this._validate(); this._updatePreview(); }));
    this._updatePreview();
    this._validate();
    this._nombre.focus();
  }

  protected buildPayload(): CatalogoItemPayload {
    return {
      id: this._item?.id ?? null,
      cultivoId: this._cultivoId,
      faseId: this._fase.value,
      sub: this._sub.value.trim(),
      nombre: this._nombre.value.trim(),
      categoria: this._categoria.value.trim(),
      unidad: this._unidad.value.trim(),
      cantUnidad: this._cantUnidad.value.trim(),
      cantidadPorHa: Number(this._cantidadPorHa.value) || 0,
      tipoP: this._tipoP.value,
      precioReferencial: this._precio.value.trim() === "" ? null : Math.max(0, Math.floor(Number(this._precio.value))),
      freq: Number(this._freq.value) || 1,
      freqUnidad: this._freqUnidad.value || null,
      incl: this._incl.value,
      nitro: this._nitro.checked,
    };
  }

  protected override onSaved(item: CatalogoItemResponse): void {
    this._onSavedCb(item);
    this.dispose();
  }

  private _updatePreview(): void {
    const qty = Number(this._cantidadPorHa.value) || 0;
    const freq = Number(this._freq.value) || 0;
    const precio = Number(this._precio.value) || 0;
    const total = qty * freq * precio;
    const ajusteTxt = this._tipoP.value === "ipc" ? " × IPC vigente" : this._tipoP.value === "smmlv" ? " (usa el factor jornal, no el precio de arriba)" : "";
    document.getElementById("mf-total")!.textContent = total > 0 ? `$${Math.round(total).toLocaleString("es-CO")}` : "$0";
    this._formula.textContent = qty > 0 && freq > 0 ? `(${qty} × ${freq} × $${precio.toLocaleString("es-CO")}${ajusteTxt})` : "";
  }

  private _validate(): void {
    const ok = this._nombre.value.trim().length >= 1
      && this._sub.value.trim().length >= 1
      && this._categoria.value.trim().length >= 1
      && this._unidad.value.trim().length >= 1
      && this._cantUnidad.value.trim().length >= 1
      && Number(this._cantidadPorHa.value) > 0
      && Number(this._freq.value) > 0;
    this.setSaveDisabled(!ok);
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
}
